import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-layout',
  templateUrl: './dynamic-layout.component.html',
  styleUrls: ['./dynamic-layout.component.css']
})
export class DynamicLayoutComponent implements OnInit {

  _dynamicData: any = null;
  tileRows: any[] = null;
  dataRows: any[] = null;

  constructor() { }

  ngOnInit() {
  }

  static getTiles(dynamicData: any): any[] {
      const tileRows = [];
      if (dynamicData != null) {
        //Determine how many rows the tile layout table needs and identify the tiles for each row by it's RowIndex (assuming that the tiles are ordered correctly on the server)
        for (let i = 0; i < dynamicData.Tiles.length; i++) {
            let ttr = tileRows[dynamicData.Tiles[i].RowIndex];
            if (typeof (ttr) === 'undefined') {
                ttr = { tiles: [] };
                tileRows[dynamicData.Tiles[i].RowIndex] = ttr;
            }
            ttr.tiles.push(dynamicData.Tiles[i]);
        }
      }
      return tileRows;
  }

  getTileData(data, tile) {
    let theData = null;
    if (data?.RowTiles != null && tile != null) {
      theData = data.RowTiles.find(f => {
        return f.DynamicLayoutTileId == tile.DynamicLayoutTileId;
      });
    }
    return theData;
  }

  @Input()
  set dynamicData(dynamicData: any) {
    this._dynamicData = dynamicData;
    if (dynamicData != null) {
        this.dataRows = dynamicData.DataRows;
        if (dynamicData.DynamicLayoutIsMainDynamicLayoutOfGroup)
            throw 'The "dynamic-grouped-layout"-component must be used with with DynamicLayoutId=' + dynamicData.DynamicLayoutId;
    }
    this.tileRows = DynamicLayoutComponent.getTiles(dynamicData);
  }

}
